import React from 'react';

import './AnimatedDots.scss';

const AnimatedDots = ({ color = 'var(--text-stressed)', size = '8px', animationSpeed = '1.5s' }) => {
  return (
    <div
      className='common-animated-dots'
      style={{ '--dot-color': color, '--dot-size': size, '--animation-speed': animationSpeed }}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default AnimatedDots;
